import { MetricWrapper, Hr } from './styled';

interface Props {
  metric: string;
  description: string;
}
export const Metric = ({ metric, description }: Props) => {
  if (metric === '' || description === '') return null;
  return (
    <>
      <Hr />
      <MetricWrapper>
        <p>{metric}</p>
        <p>{description}</p>
      </MetricWrapper>
    </>
  );
};
